var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon';
import { UnstyledButton } from '../Buttons';
import { SpanHeading } from '../Typography';
import media from '../../utils/media';
import { OnClickFocusWrapper } from '../UtilityWrappers';
const ButtonContainer = styled(UnstyledButton) `
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  border: none;
  margin: 0;
  min-height: 105px;
  cursor: pointer;
  padding: 0px 20px;

  ${media.mobile} {
    padding: 20px 20px 0px;
  }
  justify-content: ${({ withLabel }) => (!withLabel ? 'flex-end' : 'space-between')};
`;
const Heading = styled(SpanHeading) `
  max-width: 920px;
  width: 100%;
  font-size: 20px;
  line-height: 25px;

  ${media.tablet} {
    font-size: 18px;
    line-height: 22px;
  }
`;
const StyledIcon = styled((_a) => {
    var { shouldImageFlip } = _a, others = __rest(_a, ["shouldImageFlip"]);
    return React.createElement(Icon, Object.assign({}, others));
}) `
  transform: ${({ shouldImageFlip }) => (shouldImageFlip ? 'scale(-1, -1)' : 'none')};
  color: ${({ theme }) => theme.primaryRed};
  font-size: 40px;
`;
export const AccordionToggleButton = ({ isOpen, onToggle, heading, showDownArrow, withLabel, }) => {
    return (React.createElement(OnClickFocusWrapper, null,
        React.createElement(ButtonContainer, { className: `toggle-button`, "aria-expanded": isOpen, onClick: onToggle, withLabel: withLabel },
            heading && (
            // className applied to change styling from parent container
            React.createElement(Heading, { className: "accordion-heading" }, heading)),
            showDownArrow && React.createElement(StyledIcon, { shouldImageFlip: isOpen }, "arrow_drop_down"))));
};
